module.exports = __webpack_public_path__ + "static/media/rgtitle.11d07a57.png";